module.exports = __webpack_public_path__ + "img/skyCloudBj2.cf8df96a.jpg";